import { navigateToUrl } from "single-spa";
import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

export interface NavApi {
  navigate(path: string, opts?: { replace?: boolean }): void;
  back(): void;
  currentPath: ReadOnlyStore<string>;
}

export function createNavApi(): NavApi {
  const path = createStore(window.location.pathname + window.location.search);
  window.addEventListener("popstate", () =>
    path.set(window.location.pathname + window.location.search),
  );
  return {
    navigate: (p, opts) => {
      if (opts?.replace) {
        window.history.replaceState({}, "", p);
        window.dispatchEvent(new PopStateEvent("popstate"));
      } else {
        navigateToUrl(p);
      }
      path.set(p);
    },
    back: () => window.history.back(),
    currentPath: path.store,
  };
}
